module.exports = __webpack_public_path__ + "3cf2ff6545d5952b6d7122a6a81da4d8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-beach.png
// module id = 961
// module chunks = 0